export default __webpack_public_path__ + "655271e0235c2d5ac6f9b45467d27bf1.png";